
import { computed, defineComponent, PropType, reactive } from 'vue'
import { NotificationSettingT } from '@/core/types/settings.types'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'
import useAccount from '@/common/composable/useAccount'

import { settings } from '@/core/realisations/settings.realisation'

export default defineComponent({
    components: { Cheap, TheButton },
    props: {
        item: {
            type: Object as PropType<NotificationSettingT>,
            required: true,
        },
    },
    emits: ['enabled', 'disabled'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()
        const notifications = useNotifications()

        const state = reactive({
            is_enabling: false,
            is_disabling: false,
        })

        const enableSetting = async () => {
            const answer = confirm(
                `Вы действительно хотите включить настройку '${props.item.description}'?`
            )
            if (!answer) return

            try {
                state.is_enabling = true

                await settings.updateNotificationSettingState(props.item.id, true)
                emit('enabled', props.item.id)
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При включении настройки произошла ошибка',
                })
            } finally {
                state.is_enabling = false
            }
        }

        const disableSetting = async () => {
            const answer = confirm(
                `Вы действительно хотите выключить настройку '${props.item.description}'?`
            )
            if (!answer) return

            try {
                state.is_disabling = true

                await settings.updateNotificationSettingState(props.item.id, false)
                emit('disabled', props.item.id)
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При выключении настройки произошла ошибка',
                })
            } finally {
                state.is_disabling = false
            }
        }

        const isCanEdit = computed(() => {
            if (havePermissions(['notification-settings-update', 'all-root-permission']))
                return true
            return false
        })

        return { state, enableSetting, disableSetting, isCanEdit }
    },
})
